<script setup lang="ts">
import crystalBallIcon from "~/assets/icons/pill/crystal-ball.svg"
/**
 * filters the search definitions for printable ones and gives the
 * most sensible ordering (text query first, then other filters
 */
const { currentSearch } = useNavigation()
const search = computed(() => currentSearch.value?.asStatic())
const facets = computed(() => {
  const definition = search.value?.definition()
  if (!isDefined(definition))
    return []

  let facets = definition.facets
  // if we have a "contains" and a "starts-with" filter we remove the starts-with
  const hasContains = any(definition.facets, f => "contains" in f.facetType)
  const hasStartsWith = any(definition.facets, f => "startsWith" in f.facetType)
  if (hasContains && hasStartsWith)
    facets = definition.facets.filter(f => !("startsWith" in f.facetType))

  return facets
})

const sorts = computed(() => {
  const definition = search.value?.definition()
  if (isDefined(definition))
    return definition.sorts
  else
    return []
})
</script>

<template>
  <div v-if="currentSearch" class="search-pill-container">
    <nav-pill-button :data-path-search-id="currentSearch.id" class="search-pill-button">
      <div v-if="search?.description()" class="search-path">
        <crystal-ball-icon class="icon" />
        <div class="description">
          {{ search.description() }}
        </div>
      </div>
      <div v-else class="search-path">
        <crystal-ball-icon class="icon" />
        <search-path-facet
          v-for="facet, key in facets"
          :key
          :facet
        />
        <search-path-sort
          v-for="sort, key in sorts"
          :key
          :sort
        />
      </div>
    </nav-pill-button>
  </div>
  <div v-else>
    ???
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.search-pill-container
  @apply overflow-hidden flex items-center w-full h-full

.search-pill-button
  @apply flex-none pr-1.5 text-[#{$pill-path-t-focused}]

.search-path
  @apply max-w-120 h-full gap-[#{$pill-gap-default}]
  @apply flex flex-none items-center h-full

.file-thumbnail
  @apply h-full aspect-square
.description
  @apply text-ellipses-inline
.icon
  @apply text-[#{$pill-t-default}]
</style>
